<!--
import Radio from "@/components/common/ui/Radio";
 <Radio
        name="typesq"
        v-model="types"
        label="1"
        text="显示文本"
      ></Radio>
      
      disabled =>false 可编辑(已经取消该元素)  实现不可编辑在class中加入disable
      name =》同input
      label =》绑定的value值
      text=》显示文本
-->
<template>
  <div class='radio curP'>
    <label class="radio-box curP cb">
      <input type="radio"
             :name='name'
             v-model="vValue"
             :value='label'
             @change="onChange" />
      <span class="radio-inner"
            :class="{'checked bgMain bdMain':label === vValue,bdSub:label !== vValue,'disabled':disabled}"></span>
      <span class='dsI'>{{text}}<slot></slot></span>
    </label>
  </div>
</template>
<script>
export default {
  name: 'radio',
  data () {
    return {
      //randomId: 'id' + Math.random().toString(36).substr(2, 3)
      valueInput: ''
    }
  },
  props: {
    value: {},
    label: {},
    name: {
      type: String,
      default: 'type'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {},
    checkObj: {
      type: Object,
      defalut:null
    },
    change: Function
  },
  methods: {
    onChange () {
       if(this.checkObj){
    		this.$nextTick(_ => {
	        this.$emit('change', this.vValue,this.checkObj);
	      })
    	}else{
    		this.$nextTick(_ => {
	        this.$emit('change', this.vValue);
	      })
    	}
	      
    }
  },
  mounted () {
    // this.$nextTick(() => {
    //   this.valueInput = this.label || this.value
    // })
  },
  computed: {
    vValue: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.radio-box {
  overflow: hidden;
}
.radio{display:inline-block;
  label {
    // display: flex;
    // flex-direction: row;
    line-height: 1.2em;
    .dsI {
      display: block;
      float: left;
      padding-left: 0.5em;
      flex: 1;
    }
  }
  .radio-inner {
    width: 1.2em;
    height: 1.2em;
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    float: left;
    &:before {
      content: "";
      display: block;
      width: 50%;
      height: 50%;
      border-radius: 50%;
      position: absolute;
      left: 0.25em;
      top: 0.25em;
      transform: scale(0);
      transition: transform 1s cubic-bezier(0.075, 0.82, 0.165, 1);
    }
  }
  .checked:before {
    content: "";
    display: block;
    width: 50%;
    height: 50%;
    border-radius: 50%;
    background-color: #fff;
    position: absolute;
    left: 0.25em;
    top: 0.25em;
    transform: scale(1);
  }
  [type="radio"] {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/Radio.vue